import moment from 'moment'
moment.locale('pt-br', {
  months: 'Janeiro,Fevereiro,Março,Abril,Maio,Junho,Julho,Agosto,Setembro,Outubro,Novembro,Dezembro'.split(','),
  monthsShort: 'Jan,Fev,Mar,Abr,Mai,Jun,Jul,Ago,Set,Out,Nov,Dez'.split(',')
})
type Lookup = {
  value: Number
  symbol: String | null
}

function nFormatter (num: Number, digits: Number) {
  const lookup: Lookup[] = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' }
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/

  const item = lookup.slice().reverse().find(function (obj: Lookup) {
    return num >= obj.value
  })

  return item ? (+num / +item.value).toFixed(+digits).replace(rx, '$1') + item.symbol : '0'
}

const formatCurrency = (value: number, digits = 2): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(value)
}

const formatNumber = (value: number, digits = 0, kFormat = false): string => {
  if (isNaN(value)) return ''
  if (kFormat && Math.abs(value) > 999) {
    return nFormatter(value, digits)
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    currency: 'BRL',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(value)
}

const formatNumberDecimal = (value: number, digits = 0, kFormat = false): string => {
  if (isNaN(value)) return ''
  if (kFormat && Math.abs(value) > 999) {
    return `${Math.sign(value) * (+(Math.abs(value) / 1000).toFixed(1))}k`
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    currency: 'BRL',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(value).replace(',', '.')
}

/**
 * Format datetime ISO to datetime pt-br
 *
 * @param {datetime} value datetime ISO
 */
const formatDateTime = (value: string): string | undefined => {
  if (value) {
    return moment.parseZone(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
}

const formatDateTimeYear = (value: string): string | undefined => {
  if (value) {
    return moment.parseZone(String(value)).format('DD/MM/YYYY')
  }
}

const formatMonth = (value: number): string | undefined => {
  if (value) {
    return moment.parseZone(String(value)).format('MMM')
  }
}

const formatDateCard = (initialDate?: moment.Moment|string|null, finalDate?: moment.Moment|string|null): string | undefined => {
  const initialDateString = moment(initialDate).format('DD/MM/YYYY')
  const finalDateString = moment().diff(moment(finalDate), 'days') === 0 ? 'agora' : moment(finalDate).format('DD/MM/YYYY')
  const finalMessage = moment().diff(moment(finalDate), 'days') === 0 ? `Últimos ${moment(finalDate).diff(moment(initialDate), 'days')} dias` : `${initialDateString} à ${finalDateString}`
  return finalMessage
}

const getRandomArbitrary = (min: number, max: number): number => {
  return Math.random() * (max - min) + min
}

export type DaysInMonth = {
  date: string
  isWeekend: boolean
}
const getDaysInMonth = (year: number, month: number): DaysInMonth[] => {
  const isActualDate = moment(`${year}-${month}`, 'YYYY-MM').isSame(moment(), 'M')

  const date = moment(`${year}-${month}`, 'YYYY-MM')
  const result: DaysInMonth[] = []
  for (let index = 1; index <= (isActualDate ? moment().date() : moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()); index++) {
    const content: DaysInMonth = {
      date: date.format('DD/MMM/YYYY'),
      isWeekend: (date.day() === 6) || (date.day() === 0)
    }

    result.push(content)
    date.add(1, 'days')
  }

  return result.reverse()
}

const formatedProduct = (productName: string): string => {
  const positionPipe = productName.search(/[|]/)
  const positionHifen = productName.search(/[-]/)

  return productName.substring(0, positionPipe > 0 ? positionPipe - 1 : positionHifen > 0 ? positionHifen - 1 : productName.length)
}

export { formatCurrency, formatNumber, formatMonth, formatNumberDecimal, formatDateTime, formatDateCard, formatDateTimeYear, getRandomArbitrary, getDaysInMonth, formatedProduct }
